export const UNSAVED_CHANGES_STRINGS = {
  title: 'Unsaved Changes',
  body:
    'Are you sure you want to leave this page? Your changes will not be saved.',
  continueEditing: 'Continue editing',
  discardChanges: 'Discard changes'
} as const;

export const WARNING_ICON_COLOR = '#E99921';

// The design's modal measures 423x184; the height follows from the content
// and the 24px padding, so only the width needs stating.
export const MODAL_WIDTH = 423;
